"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyScheduleControlInteractor = void 0;
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
const CommonScheduleControlInteractor_1 = require("../../CommonScheduleControlInteractor");
const helpers_1 = require("../../helpers");
require("../../models");
const MonthlyScheduleHarmonizationManager_1 = require("../../MonthlyScheduleHarmonizationManager");
const types_1 = require("../../types");
class MonthlyScheduleControlInteractor extends CommonScheduleControlInteractor_1.CommonScheduleControlInteractor {
    constructor(controlModel, texts, retentionFieldsSettings, models, handlers, columns = helpers_1.getMonthlyColumns(texts.matrix)) {
        super(controlModel, texts, columns);
        this.controlModel = controlModel;
        this.texts = texts;
        this.retentionFieldsSettings = retentionFieldsSettings;
        this.models = models;
        this.handlers = handlers;
        this.columns = columns;
        this.subscriptions = new rxjs_1.Subscription();
        this.getRows = () => {
            const modelValue = this.controlModel.getValue();
            return helpers_1.getCommonScheduleRows(modelValue, this.texts, this.getScheduleRowsVisibilityData(), modelValue.isArchiveEnabled);
        };
        this.handleDone = () => {
            this.handlers.onDone(this.controlModel.getValue());
        };
        this.handleCancel = () => {
            if (this.form.hasChanges()) {
                this.handlers.onCancel();
                return;
            }
            this.handlers.onClose();
        };
        this.isArchiveVisible = (isGlobalArchiveEnabled) => {
            return helpers_1.isArchiveFieldVisible(this.controlModel.getValue().isArchiveVisible, isGlobalArchiveEnabled);
        };
        this.isArchiveDisabled = () => {
            return !this.harmonizationManager.canArchiveBeEnabled();
        };
        this.getFieldTimeOptions = () => {
            const modelValue = this.controlModel.getValue();
            const isArchive = modelValue.isArchiveEnabled;
            return helpers_1.getOptionsList(this.harmonizationManager.getFieldTimeOptions(isArchive));
        };
        this.isFieldTimeDisabled = () => {
            return this.harmonizationManager.isFieldTimeDisabled();
        };
        this.getFieldDayNumberInMonthOptions = () => {
            return helpers_1.getTextOptionsList(this.harmonizationManager.getFieldDayNumberInMonthOptions(), this.texts);
        };
        this.getFieldDayOfMonthOptions = () => {
            return helpers_1.getDayListFromSchedule(this.controlModel.getValue().rowFirstScheduleValue);
        };
        this.isFieldDayOfMonthVisible = () => {
            return this.controlModel.getValue().fieldDayNumberInMonthValue === types_1.DAY_NUMBER_IN_MONTH.onDay;
        };
        this.getFieldDayOfWeekOptions = () => {
            const modelValue = this.controlModel.getValue();
            const isArchive = modelValue.isArchiveEnabled;
            return helpers_1.getTextOptionsList(this.harmonizationManager.getFieldDayOfWeekOptions(isArchive), this.texts);
        };
        this.isFieldDayOfWeekVisible = () => {
            return this.controlModel.getValue().fieldDayNumberInMonthValue !== types_1.DAY_NUMBER_IN_MONTH.onDay;
        };
        this.isFieldDayOfWeekDisabled = () => {
            return this.harmonizationManager.isFieldDayOfWeekDisabled();
        };
        this.isMissedBackupsWarningVisible = () => {
            return !this.harmonizationManager.canArchiveBeEnabled();
        };
        this.texts = texts;
        this.controlModel = controlModel;
        this.models = models;
        this.handlers = handlers;
        this.form = new core_1.Form(this.controlModel, {
            validationSchema: Object.assign(Object.assign({}, CommonScheduleControlInteractor_1.CommonScheduleControlInteractor.getScheduleRowsValidations(this.texts.errorTextFirstScheduleIsRequired, models.dailyScheduleModel.isSecondRowExistingAndEnabled(), models.dailyScheduleModel.isThirdRowExistingAndEnabled(), retentionFieldsSettings.rowFirstFieldCountMin, retentionFieldsSettings.rowFirstFieldCountMax, retentionFieldsSettings.rowSecondFieldCountMin, retentionFieldsSettings.rowSecondFieldCountMax, retentionFieldsSettings.rowThirdFieldCountMin, retentionFieldsSettings.rowThirdFieldCountMax)), { fieldTimeValue: [core_1.required()], fieldDayOfMonthValue: [core_1.required()], fieldDayOfWeekValue: [
                    core_1.conditions({
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.first,
                    }, core_1.required()),
                    core_1.conditions({
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.second,
                    }, core_1.required()),
                    core_1.conditions({
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.third,
                    }, core_1.required()),
                    core_1.conditions({
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.fourth,
                    }, core_1.required()),
                    core_1.conditions({
                        fieldDayNumberInMonthValue: types_1.DAY_NUMBER_IN_MONTH.last,
                    }, core_1.required()),
                ] }),
        });
        this.harmonizationManager = new MonthlyScheduleHarmonizationManager_1.MonthlyScheduleHarmonizationManager(this.models.monthlyScheduleModel, this.controlModel, this.models, retentionFieldsSettings);
        this.scheduleMatrixLegendFooter = components_1.createSchedulingMatrixLegendFooter({
            texts: {
                label: this.texts.matrixFooterSelectModeLabel,
                selectMode: this.texts.matrixFooterSelectModeSelectLabel,
                unselectMode: this.texts.matrixFooterSelectModeUnselectLabel,
            },
        });
        this.fieldTimeComboboxModel = new core_1.Model(this.getFieldTimeOptions());
        this.scheduleRetentionTypeComboboxModel = new core_1.Model(this.getScheduleRetentionTypeOptions());
        this.fieldDayNumberInMonthComboboxModel = new core_1.Model(this.getFieldDayNumberInMonthOptions());
        this.fieldDayOfMonthComboboxModel = new core_1.Model(this.getFieldDayOfMonthOptions());
        this.fieldDayOfWeekComboboxModel = new core_1.Model(this.getFieldDayOfWeekOptions());
    }
    didActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions
                .add(this.controlModel.fieldChanges('isArchiveEnabled').subscribe(() => {
                this.fieldTimeComboboxModel.setValue(this.getFieldTimeOptions());
                this.fieldDayOfWeekComboboxModel.setValue(this.getFieldDayOfWeekOptions());
                this.controlModel.setValue(this.harmonizationManager.harmonizeControl());
            }))
                .add(this.controlModel.fieldChanges('fieldDayNumberInMonthValue').subscribe(() => {
                this.fieldTimeComboboxModel.setValue(this.getFieldTimeOptions());
                this.fieldDayOfWeekComboboxModel.setValue(this.getFieldDayOfWeekOptions());
                this.controlModel.setValue(this.harmonizationManager.harmonizeControl());
            }));
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.unsubscribe();
        });
    }
}
exports.MonthlyScheduleControlInteractor = MonthlyScheduleControlInteractor;
//# sourceMappingURL=MonthlyScheduleControlInteractor.js.map